export default __webpack_public_path__ + "assets/images/0880a3f4974e9da5be408a65515bf179.png";